export const skillActivities = [
    {
        title: "Quantitative Ability",
        activities: [
            "Organize BizMath Simulation Days where students solve real-world business math problems like inventory management, pricing strategies, and loan amortization.",
            "Set up Peer Math Coaching Circles where students from math-heavy backgrounds host weekly concept clarifications and group problem solving sessions.",
            "Introduce a Quant Skill Bingo challenge with tasks such as solving logic puzzles, permutation problems, and creating original quant questions — gamifying practice and rewarding progress."
        ]
    },
    {
        title: "Attention to Detail",
        activities: [
            "Run a weekly “Detail Hunt” Game Board featuring materials like CVs, financial reports, or posters embedded with minor errors; students submit findings for rewards.",
            "Assign Microtask Audits where students perform quality checks on real college documents such as attendance sheets, event budgets, or brochures to practice accuracy in practical contexts.",
            "Conduct “Zoom-In” Challenges by sharing zoomed-in snippets of images, graphs, or text and asking students to spot missing or incorrect details as a fun observation drill."
        ]
    },
    {
        title: "Data Interpretation",
        activities: [
            "<strong>Campus Data Projects</strong>: Use real data—like canteen footfall, library checkouts, or event attendance—for analysis.",
            "<strong>Mini-Case Mondays</strong>: Weekly 30-min sessions where students solve a small data puzzle (e.g., Excel-based decision problem)."
        ]
    },
    {
        title: "Negotiation",
        activities: [
            "<strong>Classroom Budget Game</strong>: Give teams fictional budgets and ask them to bid, trade, and negotiate to \"purchase\" topics or presentation slots.",
            "<strong>Mock Negotiation Day</strong>: One afternoon per semester where students act as HR managers, vendors, clients, etc., in common business negotiation scenarios."
        ]
    },
    {
        title: "Written Communication",
        activities: [
            "Campus Article Exchange</strong>: Monthly student-driven newsletter where students write about campus issues, interview teachers, or review books.",
            "“Email of the Week” Contest</strong>: Students write a professional email responding to a prompt—best one gets shared with the batch."
        ]
    },
    {
        title: "Verbal Communication",
        activities: [
            "<strong>Stand-up Speeches</strong>: Start some classes with a 2-minute informal talk by a random student on any non-academic topic.",
            "<strong>Speaking Circles</strong>: Small peer groups that meet weekly for informal debates or discussions—no pressure, just practice."
        ]
    },
    {
        title: "Problem Solving",
        activities: [
            "<strong>Local Problem Hackathons</strong>: Pick small campus/community issues (e.g., plastic use, event attendance) and ask students to design low-cost solutions.",
            "<strong>Case of the Week Wall</strong>: Put up a new real-life business or social challenge weekly and ask students to drop written solutions anonymously."
        ]
    },
    {
        title: "Business Acumen",
        activities: [
            "<strong>Startup Shadowing Program</strong>: Partner with local startups for short virtual/physical observation visits or tasks.",
            "<strong>Case Study Competitions</strong>: Encourage students to participate in case study competitions held by companies and colleges."
        ]
    }
];
